let wn = [
  [
    `Wall of Happiness
MGallery by Sofitel, The Retreat Palm Dubai
Nov 2017`,
    "wallofhappiness.jpg"
  ],
  [
    `Mosaic as Contemporary Art
Exhibition place in the National Bank of Serbia
Nov 2017`,
    "mozaik_kao_savremena_umetnost_2017.jpg"
  ],
  [
    `Express yourself in 30x30
Marsam Mattar Gallery ,Dubai
1 - 30 Oct 2017
`,
    "express_yourself_in_30x30.jpg"
  ],
  [
    `Design for the senses
Dubai World Trade Center
22 - 25 May 2017`,
    "design_for_the_senses.jpg"
  ],
  [
    `SME WORLD SUMMIT ART EXHIBITION
Jumeirah Beach Hotel, Dubai
22 Mar 2017 `,
    "whitehorse.jpg"
  ],
  [
    `Collage
Al Quattara Art Centre, Al Ain
5 Mar - 18 May 2017 `,
    "collage_mixed_media.jpg"
  ],
  [
    `Be Bold for Change
Crowne Plaza, Dubai
8 Mar - 30 Apr 2017`,
    "bebold.jpg"
  ],
  [
    `Small Scale Mosaic Exhibition
Small Galery (ULUPUDS), Belgrade Serbia
30 Oct - 10 Nov 2016`,
    "maliformat.png"
  ],
  [
    `Belgrade Mosaics Festival
Kuca Legata, Begrade, Serbia
16 Sep - 13 Oct 2016`,
    "beograd.jpg"
  ],
  [
    `Exhibition Transition - Rebirth
Pro Art Gallery, Dubai
2 - 30 Jun 2016 `,
    "proart.png"
  ],
  [
    `The Big Picture Art Exhibition
Andakulova Gallery(previously Alif Gallery), DIFC Dubai
3 - 30 Jun 2016`,
    "andakulova.png"
  ],
  [
    `Women's Peek Performance Summit Exhibtion
Anantara Eastern Mangroves, Abu Dhabi
28 May 2016 `,
    "13227645_1086419941415894_8962242256747161177_o-copy.jpg"
  ],
  [
    `XV International Contemporary Mosaic Association Congress
Palazzo della "Magnifica Thadea", Spilimbergo, Italy
18 - 22 May 2016 `,
    "DSC_8124-1-copy.jpg"
  ],
  [
    `Ras Al Khaimah Fine Arts Festival
Ras Al Khaimah Museum
19 - 25 February 2016 `,
    "DSC_7219.jpg"
  ]
];

export default wn;
